import type { TemplateDto } from '@app/api/routes/templates/dtos'
import type { FilterOption } from '@app/types/filter'

export const getFilterTemplatesFromEntities = (entityResponse?: TemplateDto[] | null): FilterOption[] =>
  entityResponse?.map(({ id, message }) => ({
    value: id,
    label: message
  })) ?? []
